"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeaderContainer = exports.StyledCollapseContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className", "prefixCls", "bordered"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Container = function Container(_ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    bordered = _ref.bordered,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledCollapse, (0, _extends2.default)({
    prefixCls: prefix,
    $bordered: bordered
  }, rest), children(prefix));
};
var StyledCollapse = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-ljv0l7-0"
})([".", "{background-color:", ";&-anim-active{transition:height 0.2s ease-out;}&-item{border:", ";border-radius:", ";margin-bottom:", ";> [class*='-header']{position:relative;height:", ";line-height:", ";padding:0px ", ";color:", ";display:flex;align-items:center;cursor:pointer;[class*='-extra-container']{display:flex;justify-content:center;align-items:center;margin-left:-5px;", "{margin-right:0px;}}", "{color:", ";transition:transform 0.2s ease;}.collapse-angle-down{position:absolute;right:16px;}}> [class*='-content']{border-radius:0 0 ", " ", ";}&-active{> [class$='-header']{.collapse-angle-down{-ms-transform:rotate(180deg);transform:rotate(180deg);}}}&:focus{box-shadow:", ";}}&-no-arrow{> [class*='-header']{flex-direction:row;}}&-collapse-border-color-danger{border-color:", ";}&-collapse-border-color-default{border-color:", ";}&-collapse-border-color-primary{border-color:", ";}&-collapse-border-color-success{border-color:", ";}&-item-disabled{[class$='-header']{cursor:not-allowed;color:", ";background-color:", ";", "{color:", ";}}}&-content{overflow:hidden;color:", ";padding:0 ", ";background-color:", ";border-top:", ";> [class*='-box']{margin-top:", ";margin-bottom:", ";}&-inactive{display:none;}}", "}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.collapse.backgroundColor;
}, function (props) {
  return props.theme.collapse.border;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.component.padding;
}, function (props) {
  return props.theme.collapse.headerHeight;
}, function (props) {
  return props.theme.collapse.headerHeight;
}, function (props) {
  return props.theme.collapse.horizontalPadding;
}, function (props) {
  return props.theme.collapse.headerColor;
}, _StyledIcon.default, _StyledIcon.default, function (props) {
  return props.theme.collapse.arrowColor;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.collapse.boxShadow;
}, function (props) {
  return props.theme.collapse.borderColor.danger;
}, function (props) {
  return props.theme.collapse.borderColor.default;
}, function (props) {
  return props.theme.collapse.borderColor.primary;
}, function (props) {
  return props.theme.collapse.borderColor.success;
}, function (props) {
  return props.theme.text.colorDisabled;
}, function (props) {
  return props.theme.collapse.disabledBg;
}, _StyledIcon.default, function (props) {
  return props.theme.collapse.disabledIconColor;
}, function (props) {
  return props.theme.text.color;
}, function (props) {
  return props.theme.collapse.horizontalPadding;
}, function (props) {
  return props.theme.collapse.backgroundColor;
}, function (props) {
  return props.theme.collapse.border;
}, function (props) {
  return props.theme.collapse.verticalPadding;
}, function (props) {
  return props.theme.collapse.verticalPadding;
}, function (props) {
  return !props.$bordered && (0, _ykbStyledComponents.css)(["> [class*='-item']{border:unset;border-radius:unset;border-bottom:1px solid ", ";margin-bottom:0px;> [class$='-content']{border-top:0;}}> [class*='-item-disabled']{[class$='-header']{background-color:unset;}}"], function (props) {
    return props.theme.border.colorBase;
  });
});
var StyledHeaderContainer = exports.StyledHeaderContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-ljv0l7-1"
})(["width:calc(100% - 40px);overflow:hidden !important;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledCollapseContainer = exports.StyledCollapseContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-ljv0l7-2"
})([""]);